export default __webpack_public_path__ + "static/media/Logistics.7bae62dc.png";